export const PAGE_TITLES = {
    HOME: 'FT Studio App',
    TASK: 'FT Studio Task',
    PREVIEW: 'FT Studio Preview',
    FEEDBACK_PREVIEW: 'FT Studio Task Preview',
    EXAM_DETAIL: 'FT Studio Exam Detail',
    EXAM_TASK: 'FT Studio Exam Task',
    RESULT: 'FT Studio Result',
    EXAM_PREVIEW: 'FT Studio Exam Preview',
    ON_HOLD_PREVIEW: 'FT Studio On Hold Task Preview',
    TIME_TRACKING: 'FT Studio Time Tracking',
} as const

export const DEBOUNCE_INTERVALS = {
    AUTO_SAVE_TASK: 3000,
}

export const NullUUID = '00000000-0000-0000-0000-000000000000'
